// Loose shape on purpose: accepts a hydrated `Boat` model as well as the raw
// API rows and payload drafts that carry only the two length fields.
export interface BoatLengthSource {
    length?: number | null;
    lengthOverall?: number | null;
}

/**
 * Single source of truth for the length a boat is measured by: the LüA (length
 * over all) wins, the hull `length` only fills in for boats without one.
 *
 * The harbour sizes and prices by LüA, so every "does it fit / how long is it"
 * consumer must agree — a berth fit check reading the hull length while the
 * booking wizard shows the LüA is what makes the same boat pass in one dialog
 * and fail in another. Display of the boat's master data (the `Länge` field
 * itself) is NOT a consumer of this — it shows what was entered.
 *
 * `||` rather than `??`: empty dimensions reach us as 0 or '', not just null.
 */
export function resolveBoatLength(boat: BoatLengthSource | null | undefined): number | null {

    if (!boat) {
        return null;
    }

    return boat.lengthOverall || boat.length || null;
}
